import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrustStripMessages as m } from './TrustStrip.messages';
import { useTheme } from '../../context/ThemeContext';

export const TrustStrip: React.FC = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const phTheme = theme === 'dark' ? 'dark' : 'neutral';
  return (
    <section className="trust-strip">
      <div className="container">
        <div className="trust-badges">
          <a href="https://www.producthunt.com/products/localingos?utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-localingos" target="_blank" rel="noopener noreferrer" className="trust-ph-badge">
            <img alt={t(m.PRODUCT_HUNT_BADGE_ALT)} width="250" height="54" src={`https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1128441&theme=${phTheme}`} />
          </a>
          <span className="trust-badge">{t(m.POWERED_BY)}</span>
          <span className="trust-sep">·</span>
          <span className="trust-badge">{t(m.BUILT_ON_AWS)}</span>
          <span className="trust-sep">·</span>
          <span className="trust-badge">{t(m.LOCALES_SUPPORTED)}</span>
          <span className="trust-sep">·</span>
          <span className="trust-badge">{t(m.SELF_LOCALIZED)}</span>
        </div>
      </div>
    </section>
  );
};
